import { render, staticRenderFns } from "./ApiCommand.vue?vue&type=template&id=2b2f8292&scoped=true&"
import script from "./ApiCommand.vue?vue&type=script&lang=js&"
export * from "./ApiCommand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2f8292",
  null
  
)

export default component.exports